import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/shangchuanzhong.png'
import _imports_1 from '@/assets/image/shenhezhong.png'
import _imports_2 from '@/assets/image/shenhetongguo.png'
import _imports_3 from '@/assets/image/fabu.png'
import _imports_4 from '@/assets/image/shenhe.png'


const _withScopeId = n => (_pushScopeId("data-v-87068ad8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"top\" data-v-87068ad8><div class=\"one\" data-v-87068ad8><img src=\"" + _imports_0 + "\" alt=\"\" data-v-87068ad8><p data-v-87068ad8>上传</p></div><div class=\"icon1 icon\" data-v-87068ad8><i class=\"iconfont left\" data-v-87068ad8></i><i class=\"iconfont left\" data-v-87068ad8></i><i class=\"iconfont left\" data-v-87068ad8></i><i class=\"iconfont content\" data-v-87068ad8></i><i class=\"iconfont left\" data-v-87068ad8></i><i class=\"iconfont left\" data-v-87068ad8></i><i class=\"iconfont left\" data-v-87068ad8></i></div><div class=\"two\" data-v-87068ad8><img src=\"" + _imports_1 + "\" alt=\"\" data-v-87068ad8><p data-v-87068ad8>作品审核中</p></div><div class=\"icon2 icon\" data-v-87068ad8><i class=\"iconfont left\" data-v-87068ad8></i><i class=\"iconfont left\" data-v-87068ad8></i><i class=\"iconfont left\" data-v-87068ad8></i><i class=\"iconfont content\" data-v-87068ad8></i><i class=\"iconfont left\" data-v-87068ad8></i><i class=\"iconfont left\" data-v-87068ad8></i><i class=\"iconfont left\" data-v-87068ad8></i></div><div class=\"three\" data-v-87068ad8><img src=\"" + _imports_2 + "\" alt=\"\" data-v-87068ad8><p data-v-87068ad8>审核通过</p></div><div class=\"icon3 icon\" data-v-87068ad8><i class=\"iconfont left\" data-v-87068ad8></i><i class=\"iconfont left\" data-v-87068ad8></i><i class=\"iconfont left\" data-v-87068ad8></i><i class=\"iconfont content\" data-v-87068ad8></i><i class=\"iconfont left\" data-v-87068ad8></i><i class=\"iconfont left\" data-v-87068ad8></i><i class=\"iconfont left\" data-v-87068ad8></i></div><div class=\"four\" data-v-87068ad8><img src=\"" + _imports_3 + "\" alt=\"\" data-v-87068ad8><p data-v-87068ad8>发布</p></div></div>", 1)
const _hoisted_3 = { class: "next" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "作品已提交审核", -1))
const _hoisted_6 = { class: "bottom" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "作品审核中", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "审核结果将在1-3个工作日内发布,请耐心等待", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"84px","height":"24px","background":"#ffeed7","border-radius":"55px","text-align":"center","margin":"0 auto"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px","color":"#ff7603"} }, "审核中")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_el_button, {
        type: "primary",
        class: "routine b1 submit",
        onClick: _ctx.returnSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode("继续上传")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _hoisted_8,
      (_ctx.workInfor.data)
        ? (_openBlock(), _createBlock(_component_el_table, {
            key: 0,
            data: _ctx.workInfor.data,
            border: "",
            "header-row-class-name": "title-name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "wid",
                label: "作品编号",
                width: "258"
              }),
              _createVNode(_component_el_table_column, {
                prop: "names",
                label: "作品名称",
                width: "257"
              }),
              _createVNode(_component_el_table_column, {
                prop: "type",
                label: "类型",
                width: "257"
              }),
              _createVNode(_component_el_table_column, {
                label: "状态",
                width: "257"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]))
        : _createCommentVNode("", true)
    ])
  ]))
}